import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'react-bootstrap';

class TourMessages extends React.Component {
  constructor(props) {
    super(props);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
  }
  handleAlertDismiss(e, msg) {
    e.preventDefault();
    this.props.messageDismiss({ key: msg.key });
  }

  render() {
    if (this.props.messages.length === 0) {
      return null;
    }
    const errors = [];
    this.props.messages.forEach((msg) => {
      errors.push(
        <Alert
          key={msg.key}
          bsStyle={msg.style}
          onDismiss={e => this.handleAlertDismiss(e, msg)}
        >
          <p>{msg.msg}</p>
        </Alert>,
      );
    });
    return (
      <div className="row" style={{ overflowY: "scroll", maxHeight: "300px" }}>
        <div className="col-sm-12">
          { errors }
        </div>
      </div>
    );
  }
}

TourMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
  messageDismiss: PropTypes.func.isRequired,
};

export default TourMessages;



// WEBPACK FOOTER //
// src/routes/tours/components/TourMessages.js